import React from 'react'

interface PopupStatusProps {
  title?: string
  icon?: string
  loader?: boolean
  class?: string
  message?: string
  buttonTitle?: string
  onClick?: () => void
}
export const PopupStatus = (props: PopupStatusProps) => {
  return (
    <div className={props?.class + ' popup-wr'}>
      <div className="popup-inner">
        {props.loader && <span className="loader-spin mb-6"></span>}
        {props.icon && (
          <img className="block mb-2" src={props.icon} alt="Icon" width={130} height={130} />
        )}
        {props.title && <h3 className="popup-title">{props.title}</h3>}
        {props.message && <p className="popup-description">{props.message}</p>}
        {props.buttonTitle && (
          <button
            className="text-center mt-6 w-full h-14 py-2.5 px-4 rounded-4xl text-[white] dark:text-black bg-buttonGradient disabled:bg-buttonDisable text-L font-bold"
            onClick={props.onClick}
          >
            {props.buttonTitle}
          </button>
        )}
      </div>
    </div>
  )
}
